import axios from 'axios'

export default {
    getCountries() {
        return axios.get('/api/countries/lookup').then(response => {
            return response.data.map(c => { return { id: c.value, name: c.label } });
        });
    }
}



// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/countryselector/api.js